export default "__VITE_ASSET__ab568b77__"